import { useState } from "react";

interface Faq {
    id: number;
    question: string;
    answer: string;
}

interface FaqProps {
    faq: Faq;
}

function FaqItem({ faq }: FaqProps) {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <div className={`border rounded-lg overflow-hidden mb-2 ${!isOpen ? "bg-[#F5F5F5]" : ""}`}>
            <button
                className="w-full text-left p-4 flex justify-between items-center focus:outline-none"
                onClick={() => setIsOpen(!isOpen)}
            >
                <span className={`font-medium ${isOpen ? "text-black" : "text-gray-700"}`}>
                    {faq.question}
                </span>
                <div>
                    <svg
                        className={`w-4 h-4 transform transition-transform ${isOpen ? "rotate-180" : "rotate-0"
                            }`}
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M5 15l7-7 7 7"
                        />
                    </svg>
                </div>
            </button>
            {isOpen && <p className="p-4 text-sm text-gray-600">{faq.answer}</p>}
        </div>
    );
}

export default FaqItem;
